export const QUESTION_MAX_LENGTH = 75;

export function sanitizeQuestionText(value: string): string {
  const withoutControls = Array.from(value)
    .map((character) => {
      const code = character.charCodeAt(0);

      return code <= 0x1f || code === 0x7f ? ' ' : character;
    })
    .join('');

  return withoutControls.replace(/\s+/g, ' ').trim().slice(0, QUESTION_MAX_LENGTH);
}

export function getQuestionCharactersLeft(value: string): number {
  return Math.max(QUESTION_MAX_LENGTH - value.length, 0);
}
